/**
 * A Kibana Discover link that shows every log line of one trace over the last year, newest first.
 * `kibanaUrl` is the environment's `kibanaURL`, which ends in a slash.
 */
export function kibanaTraceUrl(kibanaUrl: string, traceId: string): string {
    return `${kibanaUrl}app/discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1y%2Fd,to:now))&_a=(columns:!(),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,key:traceId,negate:!f,params:(query:'${traceId}'),type:phrase),query:(match_phrase:(traceId:'${traceId}')))),interval:auto,query:(language:kuery,query:''),sort:!(!('@timestamp',desc)))`;
}
